import React, { useState, Component, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { Dropdown, Button, Col, Table, Card } from "react-bootstrap";
import Calendar from "react-calendar";

import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import PageTitle from "./../../layouts/PageTitle";

//import Images:
import avatar from "../../../images/avatar/1.jpg";
import avatar1 from "../../../images/avatar/2.jpg";
import avatar2 from "../../../images/avatar/3.jpg";
import sleepSchedulePreQr from "../../../images/sleep-schedule-qrcode/pre.png";
import sleepSchedulePostQr from "../../../images/sleep-schedule-qrcode/post.png";
import sleepScheduleNotSubmittedQr from "../../../images/sleep-schedule-qrcode/not-submitted.png";
import sleepScheduleSubmittedQr from "../../../images/sleep-schedule-qrcode/submitted.png";
import { useAuth } from "../../../context/AuthContext";
import { db, storage } from "../../../firebase";
import {
  query,
  endAt,
  getDocs,
  collection,
  orderBy,
  limit,
  startAfter,
  endBefore,
  limitToLast,
  startAt,
  getCountFromServer,
  where,
  doc,
  deleteDoc,
  updateDoc,
  setDoc,
  collectionGroup,
  Timestamp,
  getDoc,
  or,
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  getBlob,
  deleteObject,
} from "firebase/storage";
import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../components/toast/SetToast";
import Toast from "../../components/toast/SetToast";
// import { useAuth } from "../../../context/AuthContext";
import {
  getThaiMonth,
  getThaiDate,
  getTomorrowDate,
} from "../Admin/DashboardUtils";
import {
  formatCpapTrialDueDate,
  getCpapTrialDaysLate,
} from "./cpapTrialDashboardDateUtils";

import { statusList } from "../Booking/BookingUtils";
import BookingAdditionalEquipment from "../Booking/BookingAdditionalEquipment";
import PatientFormQrModal from "../Patient/PatientFormQrModal";
import {
  buildPatientFormLink,
  createSleepScheduleFormRecord,
  getPatientDisplayName,
  POST_SLEEP_FORM_NAME,
  PRE_SLEEP_FORM_NAME,
} from "../Patient/patientFormQrUtils";
import { getPatientPagePath } from "../../../utils/patientPageUtils";
import { filterRecordsByStaffCustomerAccess } from "../../../utils/staffCustomerAccess";
import "./Dashboard.css";
import CpapTrialOverdueSummary from "./CpapTrialOverdueSummary";
import { mapDashboardRows, shareDashboardRequest } from "./dashboardLoadingUtils";

const SLEEP_SCHEDULE_FORM_TYPES = [
  {
    name: PRE_SLEEP_FORM_NAME,
    shortLabel: "ก่อนตรวจ",
  },
  {
    name: POST_SLEEP_FORM_NAME,
    shortLabel: "หลังตรวจ",
  },
];

const SLEEP_SCHEDULE_HEADER_STICKY_STYLE = {
  position: "sticky",
  top: "7.5rem",
  zIndex: 2,
  whiteSpace: "nowrap",
};

const ScheduleFormQrCell = ({
  form,
  formName,
  label,
  onShowQr,
  onGenerate,
  isGenerating,
  isLoading,
  canGenerate,
}) => {
  if (isLoading) return <small className="text-muted">Loading...</small>;
  if (form && form.url) {
    const questionnaireImage =
      formName === PRE_SLEEP_FORM_NAME
        ? sleepSchedulePreQr
        : sleepSchedulePostQr;
    const submissionImage = form.submit
      ? sleepScheduleSubmittedQr
      : sleepScheduleNotSubmittedQr;

    return (
      <button
        type="button"
        className="btn btn-link p-0 border-0 text-center"
        style={{ minWidth: 64 }}
        onClick={onShowQr}
        title={`Show ${label} form QR code`}
      >
        <span
          className="d-block mx-auto"
          style={{ position: "relative", width: 58, height: 58 }}
        >
          <img
            src={questionnaireImage}
            alt=""
            aria-hidden="true"
            style={{ width: "100%", height: "100%", display: "block" }}
          />
          <img
            src={submissionImage}
            alt=""
            aria-hidden="true"
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
            }}
          />
        </span>
        <span className="sr-only">
          {label}: {form.submit ? "Submitted" : "Not submitted"}
        </span>
      </button>
    );
  }

  if (!canGenerate) {
    return <small className="text-muted">No patient</small>;
  }

  return (
    <Button
      variant="outline-primary"
      size="sm"
      style={{ fontSize: 10, lineHeight: 1.15, minWidth: 80 }}
      onClick={onGenerate}
      disabled={isGenerating}
    >
      {isGenerating ? "Creating..." : "Generate"}
    </Button>
  );
};

const ScheduleTableHeader = () => (
  <thead>
    <tr>
      <th
        className="bg-primary text-white text-center"
        style={{ ...SLEEP_SCHEDULE_HEADER_STICKY_STYLE, width: 44 }}
      >
        ลำดับ
      </th>
      <th
        className="bg-primary text-white"
        style={SLEEP_SCHEDULE_HEADER_STICKY_STYLE}
      >
        ผู้ป่วย / การนัด
      </th>
      <th
        className="bg-primary text-white"
        style={SLEEP_SCHEDULE_HEADER_STICKY_STYLE}
      >
        ติดต่อ / Technician
      </th>
      <th
        className="bg-primary text-white text-center"
        style={SLEEP_SCHEDULE_HEADER_STICKY_STYLE}
      >
        ก่อนตรวจ
      </th>
      <th
        className="bg-primary text-white text-center"
        style={SLEEP_SCHEDULE_HEADER_STICKY_STYLE}
      >
        หลังตรวจ
      </th>
    </tr>
  </thead>
);

const Dashboard = () => {
  const { currentUser } = useAuth();
  const [bookingMonthCount, setBookingMonthCount] = useState(0);
  const [bookingMonthCountCash, setBookingMonthCountCash] = useState(0);

  const [cpapTrialMonthCount, setCPAPTrialMonthCount] = useState(0);
  const [cpapSaleMonthCount, setCPAPSaleMonthCount] = useState(0);
  const [cpapSaleMonthWaitingCount, setCPAPSaleMonthWaitingCount] = useState(0);
  const [bookingToday, setBookingToday] = useState([]);
  const [bookingTomorrow, setBookingTomorrow] = useState([]);
  const [bookingYesterday, setBookingYesterday] = useState([]);
  const [cpapListToday, setCPAPListToday] = useState([]);
  const [cpapDetailsLoading, setCpapDetailsLoading] = useState(false);
  const pendingPatients = useRef(new Map());
  const pendingForms = useRef(new Map());
  const [bookingHFN, setBookingHFN] = useState(0);
  const [bookingFN, setBookingFN] = useState(0);
  const [bookingSN, setBookingSN] = useState(0);
  const [bookingTitrat, setBookingTitrat] = useState(0);
  const [availableCPAP, setAvailableCPAP] = useState(0);
  const [userInfo, setUserInfo] = useState(null);
  const [qrModalData, setQrModalData] = useState(null);
  const [generatingFormKey, setGeneratingFormKey] = useState("");
  const [showYesterday, setShowYesterday] = useState(false);
  const [isLoadingYesterday, setIsLoadingYesterday] = useState(false);
  const [hasLoadedYesterday, setHasLoadedYesterday] = useState(false);

  const filterBookingsForAdminAccess = (bookings, admin) => {
    const nodeFilteredBookings = admin
      ? bookings.filter(
          (booking) =>
            booking.extendedProps &&
            booking.extendedProps.node &&
            admin.node.includes(booking.extendedProps.node),
        )
      : bookings;

    return filterRecordsByStaffCustomerAccess({
      records: nodeFilteredBookings,
      currentUser,
      adminData: admin,
      nodes: (admin && admin.allowedNodeDocs) || [],
      getNodeValue: (booking) =>
        booking.extendedProps && booking.extendedProps.node,
      getCustomerValue: (booking) =>
        booking.extendedProps && booking.extendedProps.customer,
    });
  };

  const getYesterdayDate = () => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  };

  const getBookingPatient = (booking) => {
    const extendedProps = booking.extendedProps || {};

    return {
      hn: extendedProps.hn || "",
      firstnameTh: extendedProps.firstname || "",
      lastnameTh: extendedProps.lastname || "",
    };
  };

  const loadPatientSnapshot = (hn) => shareDashboardRequest(pendingPatients.current, hn, () =>
    getDoc(doc(db, "patients", hn)));

  const loadBookingQuestionnaireForms = async (booking) => {
    const fallbackPatient = getBookingPatient(booking);

    if (!fallbackPatient.hn) {
      return {
        ...booking,
        patientInfo: fallbackPatient,
        sleepQuestionnaireForms: {},
        canGenerateSleepQuestionnaires: false,
      };
    }

    try {
      const [patientSnapshot, formsSnapshot] = await Promise.all([
        loadPatientSnapshot(fallbackPatient.hn),
        shareDashboardRequest(pendingForms.current, fallbackPatient.hn, () =>
          getDocs(collection(db, "patients", fallbackPatient.hn, "form"))),
      ]);
      const patientInfo = {
        ...fallbackPatient,
        ...(patientSnapshot.exists() ? patientSnapshot.data() : {}),
        hn: fallbackPatient.hn,
      };
      const formsByName = {};

      formsSnapshot.forEach((formSnapshot) => {
        const formData = formSnapshot.data();
        if (formData.formname) {
          formsByName[formData.formname] = {
            ...formData,
            uuid: formData.uuid || formSnapshot.id,
          };
        }
      });

      const sleepQuestionnaireForms = {};
      SLEEP_SCHEDULE_FORM_TYPES.forEach((formType) => {
        const formData = formsByName[formType.name];
        sleepQuestionnaireForms[formType.name] =
          formData && formData.assign !== false
            ? {
                ...formData,
                url: buildPatientFormLink(
                  formType.name,
                  formData.uuid,
                  patientInfo,
                  Boolean(formData.submit),
                ),
              }
            : null;
      });

      return {
        ...booking,
        patientInfo,
        sleepQuestionnaireForms,
        canGenerateSleepQuestionnaires: patientSnapshot.exists(),
      };
    } catch (error) {
      console.error(
        `Unable to load questionnaire forms for HN ${fallbackPatient.hn}`,
        error,
      );
      return {
        ...booking,
        patientInfo: fallbackPatient,
        sleepQuestionnaireForms: {},
        canGenerateSleepQuestionnaires: false,
      };
    }
  };

  const updateBookingQuestionnaireForm = (booking, formName, formData) => {
    const updateRows = (rows) =>
      rows.map((row) =>
        row === booking
          ? {
              ...row,
              sleepQuestionnaireForms: {
                ...(row.sleepQuestionnaireForms || {}),
                [formName]: formData,
              },
            }
          : row,
      );

    setBookingToday((rows) => updateRows(rows));
    setBookingTomorrow((rows) => updateRows(rows));
    setBookingYesterday((rows) => updateRows(rows));
  };

  const openScheduleFormQr = (booking, formName) => {
    const formData =
      booking.sleepQuestionnaireForms &&
      booking.sleepQuestionnaireForms[formName];

    if (!formData || !formData.url) {
      notifyWarning("Please generate the form first");
      return;
    }

    const extendedProps = booking.extendedProps || {};
    setQrModalData({
      formName,
      url: formData.url,
      order: extendedProps.order || "",
      patientName: getPatientDisplayName(booking.patientInfo),
      hn: (booking.patientInfo && booking.patientInfo.hn) || extendedProps.hn,
      submitted: Boolean(formData.submit),
    });
  };

  const generateScheduleForm = async (booking, formName) => {
    const patientInfo = booking.patientInfo || getBookingPatient(booking);
    const hn = patientInfo.hn;

    if (!hn || !booking.canGenerateSleepQuestionnaires) {
      notifyWarning("Patient information is not available for this booking");
      return;
    }

    const formKey = `${hn}-${formName}`;
    setGeneratingFormKey(formKey);

    try {
      const formCollection = collection(db, "patients", hn, "form");
      const formsSnapshot = await getDocs(formCollection);
      let existingForm = null;

      formsSnapshot.forEach((formSnapshot) => {
        const formData = formSnapshot.data();
        if (
          !existingForm &&
          formData.formname === formName &&
          formData.assign !== false
        ) {
          existingForm = {
            ...formData,
            uuid: formData.uuid || formSnapshot.id,
          };
        }
      });

      if (!existingForm) {
        const formDocRef = doc(formCollection);
        existingForm = createSleepScheduleFormRecord(
          formName,
          formDocRef.id,
          currentUser.displayName || currentUser.email || "",
        );
        await setDoc(formDocRef, existingForm);
      }

      const formData = {
        ...existingForm,
        url: buildPatientFormLink(
          formName,
          existingForm.uuid,
          patientInfo,
          Boolean(existingForm.submit),
        ),
      };
      updateBookingQuestionnaireForm(booking, formName, formData);
      notifyTopRight("Patient form is ready");

      const extendedProps = booking.extendedProps || {};
      setQrModalData({
        formName,
        url: formData.url,
        order: extendedProps.order || "",
      patientName: getPatientDisplayName(patientInfo),
      hn,
      submitted: Boolean(formData.submit),
      });
    } catch (error) {
      console.error("Unable to generate patient form", error);
      notifyError("Unable to generate patient form");
    } finally {
      setGeneratingFormKey("");
    }
  };

  const GetBookingToday = async (admin) => {
    const TodayDateString = new Date().toISOString().slice(0, 10);
    const TodayDate = Timestamp.fromDate(
      new Date(TodayDateString + "T00:00:00"),
    );
    const TomorrowDate = Timestamp.fromDate(
      new Date(TodayDateString + "T23:59:59"),
    );
    // const statusFilter = ["Sleep Test Scheduled"]
    var bookingsCollectionGroupRef = collectionGroup(db, "bookings");
    var queryConstraints = [];
    queryConstraints.push(orderBy("start"));
    queryConstraints.push(orderBy("extendedProps.customer"));
    queryConstraints.push(orderBy("extendedProps.order"));
    queryConstraints.push(where("start", ">=", TodayDate));
    queryConstraints.push(where("start", "<=", TomorrowDate));
    queryConstraints.push(
      where("extendedProps.status", "==", "Sleep Test Scheduled"),
    );
    if (currentUser.roles[0] == "sleep_technician") {
      queryConstraints.push(
        where("extendedProps.techrecord", "==", currentUser.displayName),
      );
    } else if (
      currentUser.roles[0] == "admin" ||
      currentUser.roles[0] == "staff"
    ) {
      if (admin) {
        queryConstraints.push(where("extendedProps.node", "in", admin.node));
      }
    }
    let queryHandler = query(bookingsCollectionGroupRef, ...queryConstraints);
    const tempBooking = [];
    const docSnap = await getDocs(queryHandler);
    if (docSnap.empty) {
      console.log("No documents found");
    } else {
      docSnap.forEach((booking) => {
        const bookingData = booking.data();
        const dateStart = new Date(bookingData.start.toDate());
        dateStart.setHours(dateStart.getHours() + 7);
        bookingData.start = dateStart.toISOString().slice(0, 10);
        tempBooking.push({ ...bookingData });
      });
    }
    const visibleBookings = filterBookingsForAdminAccess(tempBooking, admin);
    setBookingToday(visibleBookings.map((booking) => ({ ...booking, isLoadingQuestionnaires: true })));
    const bookingsWithQuestionnaireForms = await mapDashboardRows(visibleBookings, loadBookingQuestionnaireForms);
    setBookingToday(bookingsWithQuestionnaireForms);
  };

  const GetBookingTomorrow = async (admin) => {
    // const TodayDateString = new Date().toISOString().slice(0, 10);
    // const TodayDate = Timestamp.fromDate(
    //   new Date(TodayDateString + "T00:00:00")
    // );
    // const TomorrowDate = Timestamp.fromDate(
    //   new Date(TodayDateString + "T23:59:59")
    // );
    // const statusFilter = ["Sleep Test Scheduled"]
    // Get today's date
    const TodayDateString = new Date().toISOString().slice(0, 10);

    // Parse it as a Date object
    const TodayDate = new Date(TodayDateString);

    // Add one day to get tomorrow's date
    const TomorrowDateObject = new Date(TodayDate);
    TomorrowDateObject.setDate(TodayDate.getDate() + 1);

    // Convert tomorrow's date to Firestore Timestamp (midnight of tomorrow)
    const TomorrowDate = Timestamp.fromDate(
      new Date(TomorrowDateObject.toISOString().slice(0, 10) + "T00:00:00"),
    );

    // Add one more day to TomorrowDateObject to get the end of tomorrow
    const TomorrowPlusOneDateObject = new Date(TomorrowDateObject);
    TomorrowPlusOneDateObject.setDate(TomorrowDateObject.getDate());

    // Convert to Firestore Timestamp (11:59:59 PM of tomorrow)
    const TomorrowPlusOneDate = Timestamp.fromDate(
      new Date(
        TomorrowPlusOneDateObject.toISOString().slice(0, 10) + "T23:59:59",
      ),
    );

    // console.log("TomorrowPlusOneDate: ", TomorrowPlusOneDate);

    var bookingsCollectionGroupRef = collectionGroup(db, "bookings");
    var queryConstraints = [];
    queryConstraints.push(orderBy("start"));
    queryConstraints.push(orderBy("extendedProps.customer"));
    queryConstraints.push(orderBy("extendedProps.order"));
    queryConstraints.push(where("start", ">=", TomorrowDate));
    queryConstraints.push(where("start", "<=", TomorrowPlusOneDate));
    queryConstraints.push(
      where("extendedProps.status", "==", "Sleep Test Scheduled"),
    );
    if (currentUser.roles[0] == "sleep_technician") {
      queryConstraints.push(
        where("extendedProps.techrecord", "==", currentUser.displayName),
      );
    } else if (
      currentUser.roles[0] == "admin" ||
      currentUser.roles[0] == "staff"
    ) {
      if (admin) {
        queryConstraints.push(where("extendedProps.node", "in", admin.node));
      }
    }

    let queryHandler = query(bookingsCollectionGroupRef, ...queryConstraints);
    const tempBooking = [];
    const docSnap = await getDocs(queryHandler);
    if (docSnap.empty) {
      console.log("No documents found");
    } else {
      docSnap.forEach((booking) => {
        const bookingData = booking.data();
        const dateStart = new Date(bookingData.start.toDate());
        dateStart.setHours(dateStart.getHours() + 7);
        bookingData.start = dateStart.toISOString().slice(0, 10);
        tempBooking.push({ ...bookingData });
      });
    }
    const visibleBookings = filterBookingsForAdminAccess(tempBooking, admin);
    setBookingTomorrow(visibleBookings.map((booking) => ({ ...booking, isLoadingQuestionnaires: true })));
    const bookingsWithQuestionnaireForms = await mapDashboardRows(visibleBookings, loadBookingQuestionnaireForms);
    setBookingTomorrow(bookingsWithQuestionnaireForms);
  };

  const GetBookingYesterday = async (admin) => {
    const today = new Date(new Date().toISOString().slice(0, 10));
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const YesterdayDateString = yesterday.toISOString().slice(0, 10);
    const YesterdayStart = Timestamp.fromDate(
      new Date(YesterdayDateString + "T00:00:00"),
    );
    const YesterdayEnd = Timestamp.fromDate(
      new Date(YesterdayDateString + "T23:59:59"),
    );
    var bookingsCollectionGroupRef = collectionGroup(db, "bookings");
    var queryConstraints = [];
    queryConstraints.push(orderBy("start"));
    queryConstraints.push(orderBy("extendedProps.customer"));
    queryConstraints.push(orderBy("extendedProps.order"));
    queryConstraints.push(where("start", ">=", YesterdayStart));
    queryConstraints.push(where("start", "<=", YesterdayEnd));
    queryConstraints.push(
      where("extendedProps.status", "==", "Sleep Test Scheduled"),
    );
    if (currentUser.roles[0] == "sleep_technician") {
      queryConstraints.push(
        where("extendedProps.techrecord", "==", currentUser.displayName),
      );
    } else if (
      currentUser.roles[0] == "admin" ||
      currentUser.roles[0] == "staff"
    ) {
      if (admin) {
        queryConstraints.push(where("extendedProps.node", "in", admin.node));
      }
    }

    const queryHandler = query(bookingsCollectionGroupRef, ...queryConstraints);
    const tempBooking = [];
    const docSnap = await getDocs(queryHandler);

    docSnap.forEach((booking) => {
      const bookingData = booking.data();
      const dateStart = new Date(bookingData.start.toDate());
      dateStart.setHours(dateStart.getHours() + 7);
      bookingData.start = dateStart.toISOString().slice(0, 10);
      tempBooking.push({ ...bookingData });
    });

    const visibleBookings = filterBookingsForAdminAccess(tempBooking, admin);
    setBookingYesterday(visibleBookings.map((booking) => ({ ...booking, isLoadingQuestionnaires: true })));
    const bookingsWithQuestionnaireForms = await mapDashboardRows(visibleBookings, loadBookingQuestionnaireForms);
    setBookingYesterday(bookingsWithQuestionnaireForms);
  };

  const toggleYesterdaySchedule = async () => {
    const willShowYesterday = !showYesterday;
    setShowYesterday(willShowYesterday);

    if (!willShowYesterday || hasLoadedYesterday) {
      return;
    }

    if (
      ["admin", "staff"].includes(currentUser.roles[0]) &&
      !userInfo
    ) {
      notifyWarning("Please wait for your dashboard access to load");
      setShowYesterday(false);
      return;
    }

    setIsLoadingYesterday(true);
    try {
      await GetBookingYesterday(userInfo);
      setHasLoadedYesterday(true);
    } catch (error) {
      console.error("Unable to load yesterday's sleep schedule", error);
      notifyError("Unable to load yesterday's sleep schedule");
    } finally {
      setIsLoadingYesterday(false);
    }
  };

  const GetBookingThisMonth = async (admin) => {
    const excludeStatus = ["Cancel", "Failure"];
    const acceptStatus = statusList.filter(
      (status) => !excludeStatus.includes(status),
    );
    // console.log("acceptStatus", acceptStatus);
    const today = new Date();

    // Set the time of the first day of the month to 00:00:00
    const firstDayOfMonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      1,
      0,
      0,
      0,
    );

    // Set the time of the last day of the month to 23:59:59
    const lastDayOfMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0,
      23,
      59,
      59,
    );

    // Convert these to Firestore-compatible Timestamps
    const firstDayString = firstDayOfMonth.toISOString(); // This will include the time as well
    const lastDayString = lastDayOfMonth.toISOString(); // This will include the time as well

    var bookingsCollectionGroupRef = collectionGroup(db, "bookings");
    var queryConstraints = [];
    queryConstraints.push(orderBy("extendedProps.latestSleepStudyDate"));
    queryConstraints.push(
      where("extendedProps.latestSleepStudyDate", ">=", firstDayString),
    );
    queryConstraints.push(
      where("extendedProps.latestSleepStudyDate", "<=", lastDayString),
    );
    queryConstraints.push(
      where("extendedProps.status", "not-in", excludeStatus),
    );
    if (currentUser.roles[0] == "sleep_technician") {
      queryConstraints.push(
        where("extendedProps.techrecord", "==", currentUser.displayName),
      );
    }
    // else if (currentUser.roles[0] == "admin" || currentUser.roles[0] == "staff") {
    //   if (admin) {
    //     queryConstraints.push(
    //       where("extendedProps.node", "in", admin.node)
    //     );

    //   }
    // }
    const isAdminOrStaff = ["admin", "staff"].includes(currentUser.roles[0]);

    const bookingSnapshots = await getDocs(query(bookingsCollectionGroupRef, ...queryConstraints));
    const bookings = bookingSnapshots.docs.map((doc) => doc.data());
    const visibleBookings = isAdminOrStaff && admin
      ? filterBookingsForAdminAccess(bookings, admin)
      : bookings;
    // Preserve the existing distinction: total/cash counts require a node,
    // while unscoped study-type counts include every matching booking.
    const bookingsWithNode = visibleBookings.filter((booking) => booking.extendedProps.node);
    setBookingMonthCount(bookingsWithNode.length);
    setBookingMonthCountCash(bookingsWithNode.filter((booking) =>
      booking.extendedProps.healthInsurance === "ชำระเงินเอง").length);
    const countType = (type) => visibleBookings.filter((booking) => booking.extendedProps.type === type).length;
    setBookingHFN(countType("Home Full Night Sleep Study"));
    setBookingFN(countType("Full Night Sleep Study"));
    setBookingSN(countType("Split Night Sleep Study"));
    setBookingTitrat(countType("CPAP Titration"));
  };

  const GetCPAPTrialThisMonth = async () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0,
    );

    const firstDayTimestamp = Timestamp.fromDate(
      new Date(firstDayOfMonth.toISOString().slice(0, 10) + "T00:00:00"),
    );
    const lastDayTimestamp = Timestamp.fromDate(
      new Date(lastDayOfMonth.toISOString().slice(0, 10) + "T23:59:59"),
    );

    var cpapCollectionRef = collection(db, "borrowings");
    var queryConstraints = [];
    queryConstraints.push(orderBy("BorrowDate"));
    queryConstraints.push(where("BorrowDate", ">=", firstDayTimestamp));
    queryConstraints.push(where("BorrowDate", "<=", lastDayTimestamp));
    queryConstraints.push(where("Activity", "==", "ยืมเครื่อง"));

    let queryHandler = query(cpapCollectionRef, ...queryConstraints);
    const querySnapshot = await getDocs(queryHandler);

    // Use a Set to filter out duplicates based on the HN field
    const uniqueHNs = new Set();
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      if (data.HN) {
        uniqueHNs.add(data.HN);
      }
    });

    const uniqueCount = uniqueHNs.size;
    setCPAPTrialMonthCount(uniqueCount);
  };

  const GetCPAPSaleThisMonth = async () => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0,
    );

    const firstDayTimestamp = Timestamp.fromDate(
      new Date(firstDayOfMonth.toISOString().slice(0, 10) + "T00:00:00"),
    );
    const lastDayTimestamp = Timestamp.fromDate(
      new Date(lastDayOfMonth.toISOString().slice(0, 10) + "T23:59:59"),
    );
    var cpapCollectionRef = collection(db, "saleOrders");
    var queryConstraints = [];
    queryConstraints.push(orderBy("receiptDate"));
    queryConstraints.push(where("receiptDate", ">=", firstDayTimestamp));
    queryConstraints.push(where("receiptDate", "<=", lastDayTimestamp));
    // queryConstraints.push(where("activity", "==", "purchase"));
    queryConstraints.push(where("status", "==", "เสร็จสิ้น"));

    let queryHandler = query(cpapCollectionRef, ...queryConstraints);

    var cpapCollectionWaitingRef = collection(db, "saleOrders");
    var queryConstraintsWaiting = [];
    queryConstraintsWaiting.push(orderBy("receiptDate"));
    queryConstraintsWaiting.push(where("receiptDate", ">=", firstDayTimestamp));
    queryConstraintsWaiting.push(where("receiptDate", "<=", lastDayTimestamp));
    // queryConstraintsWaiting.push(where("activity", "==", "purchase"));
    queryConstraintsWaiting.push(where("status", "==", "กำลังดำเนินการ"));

    let queryHandlerWaiting = query(
      cpapCollectionWaitingRef,
      ...queryConstraintsWaiting,
    );
    const [countData, countDataWaiting] = await Promise.all([
      getCountFromServer(queryHandler),
      getCountFromServer(queryHandlerWaiting),
    ]);
    setCPAPSaleMonthCount(countData.data().count);
    const countWaiting = countDataWaiting.data().count;
    setCPAPSaleMonthWaitingCount(countWaiting);
  };

  const GetCPAPBorrowingAvailable = async () => {
    const cpapCollectionGroupRef = collection(db, "cpaps");

    const query1 = query(cpapCollectionGroupRef, where("Status", "==", "ว่าง"));

    const countSnapshot = await getCountFromServer(query1);
    setAvailableCPAP(countSnapshot.data().count);
  };

  const GetCpapListToday = async () => {
    setCpapDetailsLoading(true);
    try {
      const TodayDateString = new Date().toISOString().slice(0, 10);
      const TomorrowDate = Timestamp.fromDate(
        new Date(TodayDateString + "T23:59:59"),
      );
      const cpapCollectionGroupRef = collection(db, "cpaps");

      const query1 = query(
        cpapCollectionGroupRef,
        orderBy("LastDueDate"),
        where("Activity", "==", "ยืมเครื่อง"),
        where("LastDueDate", "<=", TomorrowDate),
      );
      const querySnapshot1 = await getDocs(query1);

      const baseRows = querySnapshot1.docs.map((docSnap) => ({
        ...docSnap.data(), Node: null, TrialType: null, Value: null, Sale: null,
      }));
      // Show devices and the model summary as soon as the main query returns.
      setCPAPListToday(baseRows);
      const patients = new Map();
      const combinedResults = await mapDashboardRows(baseRows, async (data) => {
        if (!data.LastHN) return data;
        try {
          if (!patients.has(data.LastHN)) {
            patients.set(data.LastHN, loadPatientSnapshot(data.LastHN));
          }
          const patientSnap = await patients.get(data.LastHN);
          if (!patientSnap.exists()) return data;
          const trialSnapshot = await getDocs(query(
            collection(db, "trial"),
            where("extendedProps.HN", "==", data.LastHN),
            where("extendedProps.SerialNumber", "==", data.SerialNumber),
            orderBy("start", "desc"),
            limit(1),
          ));
          const trialProps = trialSnapshot.empty ? {} : trialSnapshot.docs[0].data().extendedProps;
          return {
            ...data,
            Node: patientSnap.data().nodeRef || null,
            TrialType: trialProps.type || null,
            Value: trialProps.totalValue == null ? null : trialProps.totalValue,
            Sale: trialProps.sale || null,
          };
        } catch (error) {
          console.error("Unable to load CPAP trial details", error);
          return data;
        }
      });
      setCPAPListToday(combinedResults);
    } finally {
      setCpapDetailsLoading(false);
    }
  };

  useEffect(() => {
    const mainWrapper = document.getElementById("main-wrapper");
    if (!mainWrapper) return undefined;

    const originalOverflow = mainWrapper.style.overflow;
    mainWrapper.style.overflow = "visible";

    return () => {
      mainWrapper.style.overflow = originalOverflow;
    };
  }, []);

  useEffect(() => {
    const loadDashboard = async () => {
      if (!currentUser) return;
      const role = currentUser.roles[0];
      let admin;
      if (["admin", "staff"].includes(role)) {
        const [nodesDocs, currentAdminDoc] = await Promise.all([
          getDocs(collection(db, "nodes")),
          getDoc(doc(db, "admins", currentUser.displayName)),
        ]);
        admin = currentAdminDoc.data();
        const nodeCodes = Array.isArray(admin.node) ? admin.node : admin.node ? [admin.node] : [];
        const nodes = nodesDocs.docs
          .map((nodeDoc) => ({ id: nodeDoc.id, ...nodeDoc.data() }))
          .filter((node) => nodeCodes.includes(node.nodecode));
        admin = { ...admin, node: nodes.map((node) => node.nodename), allowedNodeDocs: nodes };
        setUserInfo(admin);
        // An empty access list must never fall back to an unrestricted query.
        if (!admin.node.length) return;
      }
      if (!["super_admin", "sale", "accountant", "sleep_technician", "admin", "staff"].includes(role)) return;
      const loaders = [GetBookingToday(admin), GetBookingTomorrow(admin), GetBookingThisMonth(admin)];
      if (["super_admin", "sale", "accountant"].includes(role)) {
        loaders.push(GetCPAPTrialThisMonth(), GetCPAPBorrowingAvailable(), GetCPAPSaleThisMonth(), GetCpapListToday());
      }
      const results = await Promise.allSettled(loaders);
      if (results.some((result) => result.status === "rejected")) {
        results.filter((result) => result.status === "rejected").forEach((result) =>
          console.error("Unable to load dashboard section", result.reason));
        notifyError("Some dashboard data could not be loaded. Please refresh to retry.");
      }
    };
    loadDashboard().catch((error) => {
      console.error("Unable to load dashboard access", error);
      notifyError("Unable to load dashboard access. Please refresh to retry.");
    });
  }, [currentUser]);

  return (
    <React.Fragment>
      <div className="mb-3">
        <h2 className="text-center">
          ภาพรวมประจำเดือน{" "}
          <strong>{getThaiMonth(new Date().getMonth())}</strong>
        </h2>
      </div>
      <div className="col-xl-12 col-xxl-12">
        <div className="row">
          <Link
            className={
              ["super_admin", "sale", "accountant"].includes(
                currentUser.roles[0],
              )
                ? "col-xl-3 col-lg-3 col-sm-3"
                : "col-xl-6 col-lg-6 col-sm-6"
            }
            to="/booking-calendar"
            // onClick={() => console.log("Kokkak")}
          >
            <div className="widget-stat card bg-primary pt-4">
              <Col className="media justify-content-center mb-3">
                <span>
                  <i className="flaticon-381-calendar-1 text-white"></i>
                </span>
              </Col>
              <Col>
                <h3 className="text-white text-center">{`จำนวนเคสทั้งหมด ${bookingMonthCount}`}</h3>
              </Col>
              <Col>
                <h5 className="text-white text-center">{`เคสเงินสด ${bookingMonthCountCash}`}</h5>
              </Col>

              <Col>
                <h5 className="text-white text-center">{`เคสประกันสังคมและอื่นๆ ${
                  bookingMonthCount - bookingMonthCountCash
                }`}</h5>
              </Col>
            </div>
          </Link>
          <Link
            className={
              ["super_admin", "sale", "accountant"].includes(
                currentUser.roles[0],
              )
                ? "col-xl-3 col-lg-3 col-sm-3"
                : "col-xl-6 col-lg-6 col-sm-6"
            }
            to="#"
            // onClick={() => console.log("Kokkak")}
          >
            <div className="widget-stat card bg-info pt-4 pb-4">
              {/* <Col className="media justify-content-center mb-3">
                <span>
                  <i className="flaticon-381-box-1 text-white"></i>
                </span>
              </Col> */}
              <Col>
                <h3 className="text-white text-center">
                  {`Full Night ${bookingFN}`}
                </h3>
              </Col>
              <Col>
                <h3 className="text-white text-center">
                  {`Split Night ${bookingSN}`}
                </h3>
              </Col>
              <Col>
                <h3 className="text-white text-center">
                  {`Home Full Night ${bookingHFN}`}
                </h3>
              </Col>
              <Col>
                <h3 className="text-white text-center">
                  {`CPAP Titration ${bookingTitrat}`}
                </h3>
              </Col>
            </div>
          </Link>
          {["super_admin", "sale", "accountant"].includes(
            currentUser.roles[0],
          ) && (
            <>
              {" "}
              <Link
                className="col-xl-3 col-lg-3 col-sm-3"
                // to="/trial-calendar"
                to={
                  currentUser.roles[0] === "super_admin"
                    ? "/trial-calendar"
                    : "#"
                }

                // onClick={() => console.log("Kokkak")}
              >
                <div className="widget-stat card bg-primary pt-4">
                  <Col className="media justify-content-center mb-3">
                    <span>
                      <i className="flaticon-381-box-2 text-white"></i>
                    </span>
                  </Col>
                  <Col>
                    <h3 className="text-white text-center">{`ยืม-เช่า เครื่องไปแล้ว ${cpapTrialMonthCount}`}</h3>
                  </Col>
                  <Col>
                    <h3 className="text-white text-center">{`เครื่องว่าง ${availableCPAP}`}</h3>
                  </Col>
                </div>
              </Link>
              <Link
                className="col-xl-3 col-lg-3 col-sm-3"
                to={
                  currentUser.roles[0] === "super_admin"
                    ? "/sale-order-list"
                    : "#"
                }
                // onClick={() => console.log("Kokkak")}
              >
                <div className="widget-stat card bg-info pt-4">
                  <Col className="media justify-content-center mb-3">
                    <span>
                      <i className="flaticon-381-briefcase text-white"></i>
                    </span>
                  </Col>
                  <Col>
                    <h3 className="text-white text-center">{`ขายเครื่องสำเร็จ ${cpapSaleMonthCount}`}</h3>
                    <h3 className="text-white text-center">{`กำลังดำเนินการ ${cpapSaleMonthWaitingCount}`}</h3>
                  </Col>
                </div>
              </Link>
            </>
          )}
        </div>
      </div>
      <div className="col-xl-12 col-xxl-12">
        <div className="row">
          <Card className="col-xl-6 col-lg-12 col-sm-12">
            <div className="d-flex justify-content-between align-items-center mt-3 mb-3 ml-1">
              <h4 className="mb-0">
                <span className="text-primary">นัดตรวจวันนี้</span>
              </h4>
              <h4 className="mb-0">
                <span className="text-primary">{getThaiDate(new Date())}</span>
              </h4>
            </div>
            <Table className="table-responsive-12 mb-0 table-striped">
              <ScheduleTableHeader />
              <tbody>
                {bookingToday.map((booking, index) => {
                  var healthInsuranceText = "";
                  var healthInsurance = booking.extendedProps.healthInsurance;
                  var typeSymbol = "";
                  var type = booking.extendedProps.type;
                  if (type === "Split Night Sleep Study") {
                    typeSymbol = "[SN]";
                  } else if (type === "Full Night Sleep Study") {
                    typeSymbol = "[FN]";
                  } else if (type === "Home Full Night Sleep Study") {
                    typeSymbol = "[HN]";
                  } else if (
                    type === "CPAP Titration" ||
                    type === "CPAP Titration Study"
                  ) {
                    typeSymbol = "[CT]";
                  } else if (type === "Overnight Pulse Oximetry Study") {
                    typeSymbol = "[OPO]";
                  } else if (type === "Multiple Sleep Latency Test") {
                    typeSymbol = "[MSLT]";
                  }

                  if (healthInsurance === "ชำระเงินเอง") {
                    healthInsuranceText = "[เงินสด]";
                  }
                  return (
                    <tr>
                      <td className="text-center" style={{ width: 44 }}>
                        {index + 1}
                      </td>
                      <td style={{ minWidth: 180 }}>
                        <Link
                          to={getPatientPagePath(booking.extendedProps.hn)}
                        >
                          {booking.extendedProps.firstname} {booking.extendedProps.lastname}
                        </Link>
                        <small className="d-block text-muted">
                          {booking.extendedProps.order || "-"} {typeSymbol} {healthInsuranceText}
                        </small>
                        <small className="d-block text-muted">
                          {booking.extendedProps.hn || "-"}
                        </small>
                      </td>
                      <td style={{ minWidth: 135 }}>
                        <div>{booking.extendedProps.phone || "-"}</div>
                        <small className="d-block text-muted">
                          Tech: {booking.extendedProps.techrecord || "-"}
                        </small>
                        <BookingAdditionalEquipment
                          value={booking.extendedProps.additionalEquipment}
                          compact
                        />
                      </td>
                      {SLEEP_SCHEDULE_FORM_TYPES.map((formType) => {
                        const formData =
                          booking.sleepQuestionnaireForms &&
                          booking.sleepQuestionnaireForms[formType.name];
                        const formKey = `${booking.extendedProps.hn}-${formType.name}`;

                        return (
                          <td
                            key={formType.name}
                            className="text-center align-middle"
                            style={{ width: 96, minWidth: 96 }}
                          >
                            <ScheduleFormQrCell
                              form={formData}
                              formName={formType.name}
                              label={formType.shortLabel}
                              canGenerate={booking.canGenerateSleepQuestionnaires}
                              isLoading={booking.isLoadingQuestionnaires}
                                isGenerating={generatingFormKey === formKey}
                              onShowQr={() => openScheduleFormQr(booking, formType.name)}
                              onGenerate={() => generateScheduleForm(booking, formType.name)}
                            />
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
                {bookingToday.length < 12 &&
                  [...Array(12 - bookingToday.length)].map((booking, index) => {
                    return (
                      <tr>
                        <td>
                          <h4>{index + bookingToday.length + 1}</h4>
                        </td>
                        <td>{""}</td>
                        <td>{""}</td>
                        <td>{""}</td>
                        <td>{""}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </Card>
          <Card className="col-xl-6 col-lg-12 col-sm-12">
            <div className="d-flex justify-content-between align-items-center mt-3 mb-3 ml-1">
              <h4 className="mb-0">
                <span className="text-primary">นัดตรวจวันพรุ่งนี้</span>
              </h4>
              <h4 className="mb-0">
                <span className="text-primary">
                  {getThaiDate(getTomorrowDate())}
                </span>
              </h4>
            </div>

            <Table className="table-responsive-12 mb-0 table-striped">
              <ScheduleTableHeader />
              <tbody>
                {bookingTomorrow.map((booking, index) => {
                  var typeSymbol = "";
                  var type = booking.extendedProps.type;
                  if (type === "Split Night Sleep Study") {
                    typeSymbol = "[SN]";
                  } else if (type === "Full Night Sleep Study") {
                    typeSymbol = "[FN]";
                  } else if (type === "Home Full Night Sleep Study") {
                    typeSymbol = "[HN]";
                  } else if (
                    type === "CPAP Titration" ||
                    type === "CPAP Titration Study"
                  ) {
                    typeSymbol = "[CT]";
                  } else if (type === "Overnight Pulse Oximetry Study") {
                    typeSymbol = "[OPO]";
                  } else if (type === "Multiple Sleep Latency Test") {
                    typeSymbol = "[MSLT]";
                  }
                  return (
                    <tr>
                      <td className="text-center" style={{ width: 44 }}>
                        {index + 1}
                      </td>
                      <td style={{ minWidth: 180 }}>
                        <Link
                          to={getPatientPagePath(booking.extendedProps.hn)}
                        >
                          {booking.extendedProps.firstname} {booking.extendedProps.lastname}
                        </Link>
                        <small className="d-block text-muted">
                          {booking.extendedProps.order || "-"} {typeSymbol}
                        </small>
                        <small className="d-block text-muted">
                          {booking.extendedProps.hn || "-"}
                        </small>
                      </td>
                      <td style={{ minWidth: 135 }}>
                        <div>{booking.extendedProps.phone || "-"}</div>
                        <small className="d-block text-muted">
                          Tech: {booking.extendedProps.techrecord || "-"}
                        </small>
                        <BookingAdditionalEquipment
                          value={booking.extendedProps.additionalEquipment}
                          compact
                        />
                      </td>
                      {SLEEP_SCHEDULE_FORM_TYPES.map((formType) => {
                        const formData =
                          booking.sleepQuestionnaireForms &&
                          booking.sleepQuestionnaireForms[formType.name];
                        const formKey = `${booking.extendedProps.hn}-${formType.name}`;

                        return (
                          <td
                            key={formType.name}
                            className="text-center align-middle"
                            style={{ width: 96, minWidth: 96 }}
                          >
                            <ScheduleFormQrCell
                              form={formData}
                              formName={formType.name}
                              label={formType.shortLabel}
                              canGenerate={booking.canGenerateSleepQuestionnaires}
                              isLoading={booking.isLoadingQuestionnaires}
                                isGenerating={generatingFormKey === formKey}
                              onShowQr={() => openScheduleFormQr(booking, formType.name)}
                              onGenerate={() => generateScheduleForm(booking, formType.name)}
                            />
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
                {bookingTomorrow.length < 12 &&
                  [...Array(12 - bookingTomorrow.length)].map(
                    (booking, index) => {
                      return (
                        <tr>
                          <td>
                            <h4>{index + bookingTomorrow.length + 1}</h4>
                          </td>
                          <td>{""}</td>
                          <td>{""}</td>
                          <td>{""}</td>
                          <td>{""}</td>
                        </tr>
                      );
                    },
                  )}
              </tbody>
            </Table>
          </Card>
          <Card className="col-xl-12 col-lg-12 col-sm-12">
            <div className="d-flex justify-content-between align-items-center mt-3 mb-3 ml-1 mr-1">
              <div>
                <h4 className="mb-1">
                  <span className="text-primary">นัดตรวจเมื่อวาน</span>
                </h4>
                <small className="text-muted">
                  {getThaiDate(getYesterdayDate())}
                </small>
              </div>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={toggleYesterdaySchedule}
                disabled={isLoadingYesterday}
                aria-expanded={showYesterday}
              >
                {isLoadingYesterday
                  ? "Loading..."
                  : showYesterday
                    ? "ซ่อนรายการ"
                    : "แสดงรายการ"}
              </Button>
            </div>
            {showYesterday && (
              <Table className="table-responsive-12 mb-0 table-striped">
                <ScheduleTableHeader />
                <tbody>
                  {bookingYesterday.map((booking, index) => {
                    var healthInsuranceText = "";
                    var healthInsurance = booking.extendedProps.healthInsurance;
                    var typeSymbol = "";
                    var type = booking.extendedProps.type;
                    if (type === "Split Night Sleep Study") {
                      typeSymbol = "[SN]";
                    } else if (type === "Full Night Sleep Study") {
                      typeSymbol = "[FN]";
                    } else if (type === "Home Full Night Sleep Study") {
                      typeSymbol = "[HN]";
                    } else if (
                      type === "CPAP Titration" ||
                      type === "CPAP Titration Study"
                    ) {
                      typeSymbol = "[CT]";
                    } else if (type === "Overnight Pulse Oximetry Study") {
                      typeSymbol = "[OPO]";
                    } else if (type === "Multiple Sleep Latency Test") {
                      typeSymbol = "[MSLT]";
                    }

                    if (healthInsurance === "ชำระเงินเอง") {
                      healthInsuranceText = "[เงินสด]";
                    }

                    return (
                      <tr>
                        <td className="text-center" style={{ width: 44 }}>
                          {index + 1}
                        </td>
                        <td style={{ minWidth: 180 }}>
                          <Link
                            to={getPatientPagePath(booking.extendedProps.hn)}
                          >
                            {booking.extendedProps.firstname} {booking.extendedProps.lastname}
                          </Link>
                          <small className="d-block text-muted">
                            {booking.extendedProps.order || "-"} {typeSymbol} {healthInsuranceText}
                          </small>
                          <small className="d-block text-muted">
                            {booking.extendedProps.hn || "-"}
                          </small>
                        </td>
                        <td style={{ minWidth: 135 }}>
                          <div>{booking.extendedProps.phone || "-"}</div>
                          <small className="d-block text-muted">
                            Tech: {booking.extendedProps.techrecord || "-"}
                          </small>
                        </td>
                        {SLEEP_SCHEDULE_FORM_TYPES.map((formType) => {
                          const formData =
                            booking.sleepQuestionnaireForms &&
                            booking.sleepQuestionnaireForms[formType.name];
                          const formKey =
                            booking.extendedProps.hn + "-" + formType.name;

                          return (
                            <td
                              key={formType.name}
                              className="text-center align-middle"
                              style={{ width: 96, minWidth: 96 }}
                            >
                              <ScheduleFormQrCell
                                form={formData}
                                formName={formType.name}
                                label={formType.shortLabel}
                                canGenerate={booking.canGenerateSleepQuestionnaires}
                                isLoading={booking.isLoadingQuestionnaires}
                                isGenerating={generatingFormKey === formKey}
                                onShowQr={() =>
                                  openScheduleFormQr(booking, formType.name)
                                }
                                onGenerate={() =>
                                  generateScheduleForm(booking, formType.name)
                                }
                              />
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                  {!isLoadingYesterday && bookingYesterday.length === 0 && (
                    <tr>
                      <td colSpan="5" className="text-center text-muted py-3">
                        ไม่มีรายการนัดตรวจเมื่อวาน
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            )}
          </Card>
          {["super_admin", "sale", "accountant"].includes(
            currentUser.roles[0],
          ) ? (
            <>
              {" "}
              <Card className="col-xl-12 col-lg-12 col-sm-12">
                <h4 className="mt-3 mb-3 ml-1">
                  <text className="text-primary">เลยกำหนดคืนเครื่อง</text>
                </h4>
                {(cpapListToday.length > 0 || !cpapDetailsLoading) && (
                  <CpapTrialOverdueSummary cpaps={cpapListToday} />
                )}
                {cpapDetailsLoading && <small className="text-muted mb-2" role="status">กำลังโหลดข้อมูลเครื่องและผู้รับผิดชอบ...</small>}
                <Table responsive size="sm" hover className="dashboard-cpap-trial-table mb-0 table-striped">
                  <thead>
                    <tr className="bg-primary text-white">
                      <th scope="col" className="text-center" style={{ width: 55 }}>ลำดับ</th>
                      <th scope="col" style={{ width: 110 }}>วันที่นัดคืน</th>
                      <th scope="col" className="text-center" style={{ width: 95 }}>เลยกำหนด (วัน)</th>
                      <th scope="col" style={{ width: 100 }}>ประเภท</th>
                      <th scope="col" className="text-right" style={{ width: 100 }}>มูลค่า (บาท)</th>
                      <th scope="col" style={{ width: 120 }}>Node</th>
                      <th scope="col" style={{ width: 170 }}>หมายเลขเครื่อง / Model</th>
                      <th scope="col" style={{ width: 195 }}>ชื่อ - นามสกุล / เบอร์ติดต่อ</th>
                      <th scope="col" style={{ width: 140 }}>Sale</th>
                      <th scope="col">Trial Note</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cpapListToday.map((cpap, index) => {
                      // console.log("cpap", cpap);
                      return (
                        <tr key={cpap.SerialNumber}>
                          <td className="text-center">{index + 1}</td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            {formatCpapTrialDueDate(cpap.LastDueDate)}
                          </td>
                          <td className="text-center">{getCpapTrialDaysLate(cpap.LastDueDate)}</td>
                          <td>
                            {cpap.TrialType == "Rental"
                              ? "เช่าเครื่อง"
                              : cpap.TrialType == "Trial"
                                ? "ทดลองใช้"
                                : "ไม่มีข้อมูล"}
                          </td>
                          <td className="text-right">
                            {cpap.Value != null && cpap.Value !== 0
                              ? cpap.Value
                              : "-"}
                          </td>

                          <td>{cpap.Node || "-"}</td>
                          <td>
                            <a href={`/cpap-page/${cpap.SerialNumber}`}>
                              {cpap.SerialNumber}
                            </a>
                            <small className="d-block text-muted">{cpap.Model || "-"}</small>
                          </td>

                          <td>
                            <a href={getPatientPagePath(cpap.LastHN)}>
                              {cpap.LastFirstName} {cpap.LastLastName}
                            </a>
                            <small className="d-block text-muted">{cpap.LastTel || "-"}</small>
                          </td>
                          <td>{cpap.Sale || "-"}</td>
                          <td className="dashboard-cpap-trial-note">{cpap.LastNote || "-"}</td>
                        </tr>
                      );
                    })}
                    {cpapListToday.length === 0 && (
                      <tr>
                        <td colSpan="10" className="text-center text-muted py-3">
                          {cpapDetailsLoading ? "กำลังโหลดรายการ..." : "ไม่มีรายการเลยกำหนดคืนเครื่อง"}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card>
            </>
          ) : (
            <> </>
          )}
        </div>
      </div>
      <PatientFormQrModal
        qrData={qrModalData}
        onHide={() => setQrModalData(null)}
      />
    </React.Fragment>
  );
};

export default Dashboard;
